// extracted by mini-css-extract-plugin
module.exports = {"form":"AddTenantModal_form__sc345","address":"AddTenantModal_address__3kze0","nameFieldsRow":"AddTenantModal_nameFieldsRow__2nzGh"};